import { LocationSettingsGeneralComponent } from 'app/components/location-settings-general/LocationSettingsGeneralComponent'
import { useLocationSettingsGeneral } from 'app/components/location-settings-general/useLocationSettingsGeneral'
import { createValidator, editValidator } from 'app/components/location-settings-general/locationGeneralValidators'

export default function General() {
  const hookData = useLocationSettingsGeneral()
  return (
    <LocationSettingsGeneralComponent {...hookData} createValidator={createValidator} editValidator={editValidator} />
  )
}
